import util from '../../../util'

const loadTariffList = ({commit}, payload) => {

  return new Promise((resolve, reject) => {

    const headers = util.getAuthHeader()

    payload.context.axios.get('api/tariffs/{clientId}', {headers}).then((response) => {

      commit('setTariffList', response.data)

      resolve(response.data)

    }).catch(error => {

      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al cargar las tarifas.')
        reject(error.response)
      }
      reject()

    });

  })

}


const loadClientById = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {

    const headers = util.getAuthHeader()
  //tariffs/{clientId}
    payload.context.axios.get('api/clients/'+payload.clientId, {headers}).then((response) => {

      resolve(response.data)

    }).catch(error => {

      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al cargar el cliente.')
        reject(error.response)
      }
      reject()

    });

  })

}

const saveTariff = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.post('api/clients',payload.client ,{headers}).then((response) => {

      resolve(response.data)

    }).catch(error => {

      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al registrar el cliente.')
        reject(error.response)
      }
      reject()

    });
  })
}

const editClient = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.put('api/clients',payload.client ,{headers}).then((response) => {

      resolve(response.data)

    }).catch(error => {

      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al actualizar el cliente.')
        reject(error.response)
      }
      reject()

    });

  })

}

const disableClient = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.patch('api/clients/'+payload.client.id+'/disable',{} ,{headers}).then((response) => {

      resolve(response.data)

    }).catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al eliminar el usuario.')
        reject(error.response)
      }
      reject()

    })
  })
}

//ACCIONES PARA USUARIOS DEL CLIENTE

const loadUserClientList = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {

    const headers = util.getAuthHeader()


    payload.context.axios.get('api/clients/'+payload.clientId+'/users', {headers}).then((response) => {

      resolve(response.data)

    }).catch(error => {

      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al cargar los usuarios del cliente.')
        reject(error.response)
      }
      reject()

    });

  })

}

const saveUserClient = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.post('api/clients/'+payload.clientId+'/users' , payload.user ,{headers}).then((response) => {

      resolve(response.data)

    }).catch(error => {

      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al registrar el usuario.')
        reject(error.response)
      }
      reject()

    });
  })
}

const editUserClient = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.put('api/clients/'+payload.clientId+'/users',payload.user ,{headers}).then((response) => {

      resolve(response.data)

    }).catch(error => {

      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al actualizar el usuario.')
        reject(error.response)
      }
      reject()

    });

  })

}

const enableUserClient = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.patch('api/clients/'+payload.clientId+'/users/'+payload.user.id+'/enable',{} ,{headers}).then((response) => {

      resolve(response.data)

    }).catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al activar el usuario.')
        reject(error.response)
      }
      reject()

    })
  })
}

const disableUserClient = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.patch('api/clients/'+payload.clientId+'/users/'+payload.user.id+'/disable',{} ,{headers}).then((response) => {

      resolve(response.data)

    }).catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al desactivar el usuario.')
        reject(error.response)
      }
      reject()

    })
  })
}

const restoreUserClientPass = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.patch('api/clients/'+payload.clientId+'/users/'+payload.user.id+'/restorepass',{} ,{headers}).then((response) => {

      resolve(response.data)

    }).catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al restablecer el usuario.')
        reject(error.response)
      }
      reject()

    })
  })
}


//ACCIONES PARA CATEGORÍA

const saveCategory = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.post('api/clients/'+payload.clientId+'/categories',payload.category ,{headers}).then((response) => {

      resolve(response.data)

    }).catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al registrar el tipo.')
        reject(error.response)
      }
      reject()

    });

  })

}

const editCategory = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.put('api/clients/'+payload.clientId+'/categories',payload.category ,{headers}).then((response) => {

      resolve(response.data)

    }).catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al actualizar el tipo.')
        reject(error.response)
      }
      reject()

    });

  })

}

const deleteCategory = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.delete('api/clients/'+payload.clientId+'/categories/'+payload.categoryId ,{headers}).then((response) => {
      resolve(response.data)

    }).catch(error => {
      if(error.response)
      {
        console.log(error)
        util.showDialogError(payload.context, 'Ocurrió un error al eliminar el tipo.')
        reject(error.response)
      }
      reject()

    });

  })

}
/**************************************NUEVO******************** */
const loadTariffsList = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()
    payload.context.axios.get(`api/tariffs/client/${payload.idClient}`, {headers}).then((response) => {
      commit('setTariffList',response.data);
      resolve(response.data)
    }).catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al cargar las tarifas del cliente.')
        reject(error.response)
      }
      reject(error.response)
    });
  })
}

const getTariffByIdTariffAndIdClient = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()
    payload.context.axios.get(`api/tariffs/tariff/${payload.idTariff}/client/${payload.idClient}`, {headers}).then((response) => {
      resolve(response.data)
    }).catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al cargar la tarifa del cliente.')
        reject(error.response)
      }
      reject(error.response)
    });
  })
}

const filterTariffByListTariff = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()
    payload.context.axios.post(`api/tariffs/filter`, payload.listselected, {headers}).then((response) => {
      resolve(response.data)
    }).catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al cargar listado de servicios de tarifa.')
        reject(error.response)
      }
      reject(error.response)
    });
  })
}


const saveTariffServices = ({commit}, payload) =>{
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()
    payload.context.axios.post(`api/tariffs/client/${payload.idClient}/services`, payload.services, {headers}).then((response) => {
      resolve(response.data)
    }).catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al registrar las tarifas del cliente.')
        reject(error.response)
      }
      reject(error.response)
    });
  })
}

const updateTariffServices = ({commit}, payload) =>{
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()
    payload.context.axios.put(`api/tariffs/client/${payload.idClient}/services`, payload.services, {headers}).then((response) => {
      resolve(response.data)
    }).catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al actualizar las tarifas del cliente.')
        reject(error.response)
      }
      reject(error.response)
    });
  })
}

const deleteTariifServices = ({commmit},payload) => {
  return new Promise((resolve,reject)=>{
    const headers = util.getAuthHeader();
    payload.context.axios.delete(`api/tariffs/${payload.id}`,{headers}).then((response)=>{
      resolve(response.data)
    }).catch(error=>{
      if(error.response)
      {
        console.log(error)
        util.showDialogError(payload.context, error.response.data.message)
        reject(error.response)
      }
      reject()
    })

  })
}

const saveRangeTariff = ({commit}, payload) =>{
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()
    payload.context.axios.post(`api/tariffs/${payload.idTariff}/range`, payload.listRangePrices, {headers}).then((response) => {
      resolve(response.data)
    }).catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al registrar los rangos de la tarifa del cliente.')
        reject(error.response)
      }
      reject(error.response)
    });
  })
}
const saveRangeTariffEdit = ({commit}, payload) =>{
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()
    payload.context.axios.put(`api/tariffs/${payload.idTariff}/range`, payload.listRangePrices, {headers}).then((response) => {
      resolve(response.data)
    }).catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al actualizar los rangos de la tarifa del cliente.')
        reject(error.response)
      }
      reject(error.response)
    });
  })
}
const deleteRangeTariff = ({commit}, payload) =>{
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()
    payload.context.axios.delete(`api/tariffs/${payload.idTariff}/range/${payload.idRange}`, {headers}).then((response) => {
      resolve(response.data)
    }).catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al eliminar el rango de la tarifa del cliente.')
        reject(error.response)
      }
      reject(error.response)
    });
  })
}

const getCountByCode = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()
    payload.context.axios.get(`api/tariffs/service/${payload.code}`, {headers}).then((response) => {
      resolve(response.data)
    }).catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, error.response.data.message)
        reject(error.response)
      }
      reject(error.response)
    });
  })
}



export default {
  loadTariffList,
  editClient,
  disableClient,
  loadClientById,

  //ACCIONES PARA USUARIOS DEL CLIENTE
  loadUserClientList,
  saveUserClient,
  editUserClient,
  enableUserClient,
  disableUserClient,
  restoreUserClientPass,

  //CATEGORÍAS
  saveCategory,
  editCategory,
  deleteCategory,

  //TARIFA SERVICES
  getTariffByIdTariffAndIdClient,
  filterTariffByListTariff,
  saveTariffServices,
  loadTariffsList,
  updateTariffServices,
  deleteTariifServices,
  saveRangeTariff,
  saveRangeTariffEdit,
  deleteRangeTariff,
  getCountByCode
};



// WEBPACK FOOTER //
// ./src/store/modules/tariff/actions.js